<template>
  <transition name="fade">
    <div
      v-if="showQuickShop"
      v-scroll-lock="showQuickShop"
      role="dialog"
      aria-modal="true"
      class="quick-shop"
    >
      <button
        @click="dismiss"
        class="quick-shop__close-button"
        aria-label="close dialog"
      >
        <icon name="close" :size="$mq === 'mobile' ? '18px' : '21px'" />
      </button>

      <div class="quick-shop__inner">
        <div class="quick-shop__content">
          <swiper
            :slides-per-view="1"
            class="quick-shop__slider"
            :options="desktopOptions"
            ref="quickShopDesktop"
          >
            <swiper-slide
              v-for="image in product.images"
              :key="image.id"
            >
              <img :src="image.src" :alt="image.alt"/>
            </swiper-slide>
            <div
              class="swiper-button-prev"
              slot="button-prev"
            >
              <span>
                <icon name="secondary_arrow_left" size="9px"></icon>
              </span>
            </div>
            <div
              class="swiper-button-next"
              slot="button-next"
            >
              <span>
                <icon name="secondary_arrow_right" size="9px"></icon>
              </span>
            </div>
          </swiper>
          <div class="quick-shop__details">
            <product-form
              :product="product"
              :collection="collection"
              :customFields="customFields"
              :settings="settings"
              v-model="variant"
              :prices="prices()"
              :reviewSource="reviewSource"
              context="quickshop"
            >
            </product-form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
import Icon from "@/scripts/components/basic/Icon.vue";
import { imageSize } from "@/scripts/helpers/util";
import ProductForm from "./ProductForm.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { sumVariantPrices } from "@/scripts/helpers/util";
import quickShopUpsell from '@/scripts/mixins/quickshopUpsell.js'

export default {
  name: "ProductQuickShop",
  mixins: [quickShopUpsell],
  props: {
    collection: Object,
    settings: {
      type: Object,
      default: () => ({ hideReviews: false }),
    },
  },
  components: {
    Icon,
    ProductForm,
    swiper,
    swiperSlide
  },
  watch: {
    sidecartOpen: function (){
      this.dismiss();
    },
    showQuickShop: function (visible) {
      if (!visible) {
        window.removeEventListener("keyup", this.escape);
        this.$store.dispatch("fullOverlay/setVisibility", visible);
        return;
      }
      this.$store.dispatch("fullOverlay/setVisibility", visible);
      this.$store.dispatch("fullOverlay/setIndex", 111);
      window.addEventListener("keyup", this.escape);
      this.$nextTick(() => {
        this.setFocusElements();
        try {
          window.yotpo.initWidgets();
        } catch (e) {
          console.error(e);
        }
      });
    },
  },
  data() {
    return {
      pseudoVariants: [],
      displayVendor: null,
      reviewSource: window.bvaccel && window.bvaccel.reviewSource,
      desktopOptions: {
        slidesPerView: "auto",
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      },
    };
  },
  computed: {
    ...mapState({
      showQuickShop: ({ quickshop }) => quickshop.showQuickShop,
      product: ({ quickshop }) => quickshop.modalContent.product,
      customFields: ({ quickshop }) => quickshop.modalContent.customFields,
      sidecartOpen: ({ cart }) => cart.sidecartOpen,
    }),
    variant: {
      get() {
        return this.$store.state.quickshop.variant;
      },
      set(variant) {
        this.$store.dispatch("quickshop/setVariant", variant);
      }
    },
    productMedia() {
      const images = this.product.media;
      return images;
    },
    swiperDesktop() {
      return this.$refs.quickShopDesktop.swiper;
    },
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.escape);
  },
  methods: {
    imageSize,
    dismiss() {
      this.$store.dispatch("quickshop/closeQuickShop");
    },
    prices() {
      const prices = sumVariantPrices(this.variant, this.selectedMagnetVariant);
      return prices;
    }
  },
};
</script>

<style lang="scss" scoped>
.quick-shop {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  max-width: percentage(345 / 375);
  background: $color-white;
  transform: translate(-50%, -50%);
  z-index: 112;
  

  @include desktop-up {
    max-width: 881px;
    padding: rem(21);
    padding-bottom: 44px;
  }
}

.quick-shop__close-button {
  display: block;
  margin-left: auto;
  margin-bottom: 21px;
}

.quick-shop__content {
  display: flex;
  margin-bottom: 21px;
  align-items: center;
}

.quick-shop__content form.product-form {
  width: auto;
  padding-left: 18px;
}

.quick-shop__slider {
  flex-basis: 50%;
  
  img {
    max-width: 86%;
    z-index: 1;
  }
}

.quick-shop__details {
  flex-basis: 50%;
}

.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  display: none;
}

.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  display: none;
}

.swiper-button-prev {
  height: 60px;
  width: 60px;
  border-radius: 60px;
  border: 1px solid $color-black-600;
  left: 0px;

  span {
    position: relative;
    width: 24px;
    &:after {
      height: 1px;
      display: block;
      content: "";
      background-color: $color-divider-dark;
      position: absolute;
      top: 50%;
      width: 100%;
    }
  }

  svg {
    position: absolute;
    top: -4px;
    left: -2px;
  }
}

.swiper-button-next {
  height: 60px;
  width: 60px;
  border-radius: 60px;
  border: 1px solid $color-black-600;
  right: 0px;

  span {
    position: relative;
    width: 24px;
    &:after {
      height: 1px;
      display: block;
      content: "";
      background-color: $color-divider-dark;
      position: absolute;
      top: 50%;
      width: 100%;
    }
  }

  svg {
    position: absolute;
    top: -4px;
    right: -2px;
  }
}

.swiper-slide {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 492px;

  &:before {
    content: '';
    background: #f8f8f8;
    width: 87%;
    height: 100%;
    position: absolute;
    top: 0;
    display: block;
  }
}
</style>